import React from 'react';

export const VendedorContactFormSection = ({
  vendedorName,
  showContactForm,
  formData,
  submitting,
  onOpenForm,
  onCloseForm,
  onFieldChange,
  onSubmit,
}) => {
  if (!showContactForm) {
    return (
      <button
        onClick={onOpenForm}
        className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl p-4 font-semibold text-lg hover:from-blue-700 hover:to-indigo-700 transition"
        data-testid="vendedor-contact-toggle-button"
      >
        💬 Enviar Mensagem para {vendedorName.split(' ')[0]}
      </button>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6" data-testid="vendedor-contact-form-card">
      <h2 className="text-xl font-bold text-gray-900 mb-4" data-testid="vendedor-contact-form-title">Enviar Mensagem</h2>

      <form onSubmit={onSubmit} className="space-y-4" data-testid="vendedor-contact-form">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Seu Nome *</label>
          <input
            type="text"
            value={formData.nome}
            onChange={(event) => onFieldChange('nome', event.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Nome completo"
            data-testid="vendedor-contact-name-input"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
          <input
            type="email"
            value={formData.email}
            onChange={(event) => onFieldChange('email', event.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="seu@email.com"
            data-testid="vendedor-contact-email-input"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
          <input
            type="tel"
            value={formData.telefone}
            onChange={(event) => onFieldChange('telefone', event.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="080-XXXX-XXXX"
            data-testid="vendedor-contact-phone-input"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Interesse</label>
          <select
            value={formData.interesse}
            onChange={(event) => onFieldChange('interesse', event.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            data-testid="vendedor-contact-interest-select"
          >
            <option value="casa">Comprar Casa</option>
            <option value="carro">Comprar Carro</option>
            <option value="reforma">Reforma</option>
            <option value="contato">Outro Assunto</option>
          </select>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCloseForm}
            className="flex-1 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50"
            data-testid="vendedor-contact-cancel-button"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={submitting}
            className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
            data-testid="vendedor-contact-submit-button"
          >
            {submitting ? 'Enviando...' : 'Enviar'}
          </button>
        </div>
      </form>
    </div>
  );
};
